import { render } from "./ReportManager.vue?vue&type=template&id=28de4a2e&scoped=true"
import script from "./ReportManager.vue?vue&type=script&lang=js"
export * from "./ReportManager.vue?vue&type=script&lang=js"

import "./ReportManager.vue?vue&type=style&index=0&id=28de4a2e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28de4a2e"]])

export default __exports__